import styled from 'styled-components';
import { StyledWrapper } from '../common/Wrapper/Wrapper.styles';
import media from '../../styles/config/mediaQueries';

const StyledCategoryNav = styled.section`
  width: 100%;
  overflow: hidden;

  ${StyledWrapper} {
    ${media.desktop`
      padding: 0;
    `}
  }
`;

const StyledCategoryMenu = styled.ul`
  display: flex;
  padding: 0;
  ${media.mobile`
    flex-direction: column;
  `}
  ${media.desktop`
    flex-wrap: wrap;
  `}
`;

export { StyledCategoryNav, StyledCategoryMenu };
